import React, { PureComponent } from 'react';
import Context from 'managers/Context';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { PATH_IMAGE } from 'constants/Environment';
import './style.scss';

class LogRow extends PureComponent {
    state = {};

    render() {
        const { log, integration, literals, integrationLogo } = this.props;
        let createdDateFormatted = '';
        let action = '';
        if (log.fcreado) {
            createdDateFormatted = Context.utilsFormats.formatStringByInputFormat(
                log.fcreado,
                'YYYY-MM-DDTHH:mm:ss',
                true,
            );
        }
        if (log.action) {
            switch (log.action) {
                case 'PUT':
                case 'PATCH':
                    if (log.result === 'succeed') {
                        action = (
                            <span>
                                <Literal
                                    literal={
                                        literals[`label_update_${log.entity}_integration`] ||
                                        `label_update_${log.entity}_integration`
                                    }
                                />
                            </span>
                        );
                    } else {
                        action = (
                            <span>
                                <Literal
                                    literal={
                                        literals[`label_failed_update_${log.entity}_integration`] ||
                                        `label_failed_update_${log.entity}_integration`
                                    }
                                />
                                <Literal
                                    literal={
                                        literals['label_entity_sync_error_integration'] ||
                                        'label_entity_sync_error_integration'
                                    }
                                />
                            </span>
                        );
                    }
                    break;
                case 'POST':
                    if ((action = log.result === 'succeed')) {
                        action = (
                            <span>
                                <Literal
                                    literal={
                                        literals[`label_insert_${log.entity}_integration`] ||
                                        `label_insert_${log.entity}_integration`
                                    }
                                />
                            </span>
                        );
                    } else {
                        action = (
                            <span>
                                <Literal
                                    literal={
                                        literals[`label_failed_insert_${log.entity}_integration`] ||
                                        `label_failed_insert_${log.entity}_integration`
                                    }
                                />
                                <Literal
                                    literal={
                                        literals['label_entity_sync_error_integration'] ||
                                        'label_entity_sync_error_integration'
                                    }
                                />
                            </span>
                        );
                    }
                    break;
                case 'DELETE':
                    if ((action = log.result === 'succeed')) {
                        action = (
                            <span>
                                <Literal
                                    literal={
                                        literals[`label_delete_${log.entity}_integration`] ||
                                        `label_delete_${log.entity}_integration`
                                    }
                                />
                            </span>
                        );
                    } else {
                        action = (
                            <span>
                                <Literal
                                    literal={
                                        literals[`label_failed_delete_${log.entity}_integration`] ||
                                        `label_failed_delete_${log.entity}_integration`
                                    }
                                />
                                <Literal
                                    literal={
                                        literals['label_entity_sync_error_integration'] ||
                                        'label_entity_sync_error_integration'
                                    }
                                />
                            </span>
                        );
                    }
                    break;
            }
        }
        let origin = (
            <div className="app-logo-container">
                {log.originApp === integration ? (
                    <img className="app-logo" src={PATH_IMAGE + integrationLogo} />
                ) : (
                    <img className="app-logo" src={PATH_IMAGE + 'forcemanager_logo.png'} />
                )}
                <div className="sync-direction-integration" />
                {log.originApp === integration ? (
                    <img className="app-logo" src={PATH_IMAGE + 'forcemanager_logo.png'} />
                ) : (
                    <img className="app-logo" src={PATH_IMAGE + integrationLogo} />
                )}
            </div>
        );
        let result =
            log.result === 'succeed' ? (
                <div className="log-succed-integration ic-thick" />
            ) : (
                <div className="log-failed-integration ic-close" />
            );
        return (
            <tr>
                <td className="w-100">{result}</td>
                <td className="w-200">{origin}</td>
                <td className="w-200">{createdDateFormatted}</td>
                {log.result === 'succeed' ? (
                    <td>
                        {action}: {log.descEntity}
                    </td>
                ) : (
                    <td className="go-to-entity">
                        {action}: {log.message}
                    </td>
                )}
            </tr>
        );
    }
}

export default LogRow;
